// eslint-disable-next-line no-restricted-properties
export var generateId = function generateId() {
  return Math.round(Math.random() * Math.pow(10, 16));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-trend/es/helpers/misc.helpers.js
// module id = 663
// module chunks = 0